import axios from 'axios';

export type HubSpotContactMatch = {
	contactId: string;
	email: string;
	firstName: string;
	lastName: string;
};

export type SearchHubSpotContactsParams = {
	search: string,
	getToken: () => Promise<string>
};

export const searchHubSpotContacts = async (params: SearchHubSpotContactsParams): Promise<[Array<HubSpotContactMatch> | null, string | null]> => {
	const { search, getToken } = params;

	try {
		const token = await getToken();
		const response = await axios.get(`${import.meta.env.VITE_API_URL}/hubspot/contacts?search=${encodeURIComponent(search)}`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});

		if (response.status !== 200) return [null, 'Unable to search HubSpot contacts.'];

		return [response.data ?? [], null];
	} catch (error) {
		return [null, error as string];
	}
};
